function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Credit Card number
 * 
 */
import React, { Component } from 'react';
import TextInput from '../../../../components/text-input/TextInput';
import { creditCard } from '../../../../actions/index';
import { connect } from 'react-redux';
import { jsx as _jsx } from "react/jsx-runtime";
class CreditCard extends Component {
  render() {
    const {
      creditCard,
      gateway,
      setCreditCard,
      submit
    } = this.props;
    const name = gateway.name === 'windcave' ? 'CardNumber' : gateway.name === 'nab-securepay' ? 'EPS_CARDNUMBER' : 'card_number';
    const values = {
      [name]: {
        ...creditCard.credit_card
      }
    };
    return /*#__PURE__*/_jsx(TextInput, {
      label: "Credit card number",
      name: name,
      handleChange: setCreditCard,
      onBlur: setCreditCard
      // $FlowFixMe
      ,
      values: values,
      placeholder: "1234 1234 1234 1234",
      section: "",
      submit: submit,
      type: "tel",
      inputMode: "numeric"
    });
  }
}
_defineProperty(CreditCard, "defaultProps", {
  creditCard: {
    creditCard: {
      display: '',
      error: false,
      required: true,
      value: '',
      valid: null
    }
  },
  gateway: {
    name: 'windcave'
  },
  setCreditCard: () => null,
  submit: false
});
const mapStateToProps = ({
  creditCard
}) => {
  return {
    creditCard
  };
};
const mapDispatchToProps = dispatch => {
  return {
    setCreditCard: value => {
      dispatch(creditCard(value));
    }
  };
};
const VisibleCreditCard = connect(mapStateToProps, mapDispatchToProps)(CreditCard);
export default VisibleCreditCard;